module.exports = __webpack_public_path__ + "static/media/me3_SSO_SocialIcon.f5f9c397.svg";